import { gql } from '@apollo/client';

export const GET_ACTIVITY_IDS = gql`
  query RostersGetActivityIds($programIds: [String!], $isActive: Boolean) {
    isLargeOrg
    vm {
      programs(programIds: $programIds) {
        activities(includeInactiveActivities: $isActive) {
          activityId
        }
      }
    }
  }
`;
